"use client";
import React from "react";
import gs from "gstyles";
import { Image } from "components/common";
const SectionDownloadApp = () => {
  return (
    <section
      className="relative flex items-end overflow-hidden bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: 'url("/bg-color.webp")' }}
    >
      <div className="container mx-auto px-4 lg:px-6">
        <div className="flex justify-center mx-auto">
          {/* Images */}
          <div className="flex-1 hidden lg:flex items-end justify-center pt-6">
            <Image
              isRelative={true}
              src="/footer-image.webp"
              wrapClassName="w-full h-auto max-w-[471px] aspect-[1058/900] object-contain hidden lg:flex"
            />
          </div>
          {/* Content */}
          <div className="flex justify-center items-center lg:items-start flex-1 flex-col pl-0 lg:pl-12 py-4 lg:py-10">
            <div className="flex mb-3 lg:mb-6">
              <h2 className="text-lg md:text-2xl lg:text-3xl font-bold text-gray-800 flex flex-col items-center gap-1 lg:gap-2">
                <span className="flex gap-4 ">
                  <span className="text-[#ff914d]">Ưu đãi</span>
                  <span className="text-[#1f9fa6]">
                    Gội đầu - Làm nail - Massage
                  </span>
                  <br />
                </span>
                <span className="text-[#1f9fa6]">chỉ có trên ứng dụng </span>
              </h2>
            </div>

            {/* Main Content Grid */}
            <div className="flex flex-col gap-4">
              <p className="text-md text-center md:text-left md:text-xl lg:text-2xl text-gray-600 mb-0">
                Tải ngay Lookme để trải nghiệm nhé
              </p>
              <div className="flex flex-col md:flex-row gap-4 md:gap-5 lg:gap-10 items-center">
                {/* Left Side - QR Code */}
                <div className="flex flex-col items-center justify-center space-y-4">
                  {/* QR Code Placeholder */}
                  <div className="w-32 h-32 bg-white rounded-2xl shadow-lg flex items-center justify-center border-2 border-dashed border-gray-300">
                    <Image
                      isRelative={true}
                      src="/dub-qrcode.png"
                      wrapClassName="relative w-full aspect-[1/1] rounded-2xl object-contain overflow-hidden"
                    />
                  </div>
                </div>
                {/* Google Play Button Placeholder */}

                <a
                  href="https://play.google.com/store/apps/details?id=com.lookme.users&hl=vi"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  {gs.icons({
                    name: "googleplay",
                    width: "180px",
                    height: "52px",
                  })}
                </a>
                {/* App Store Button Placeholder */}
                <a
                  href="https://apps.apple.com/vn/app/lookme-%C4%91%E1%BA%B7t-l%E1%BB%8Bch-l%C3%A0m-%C4%91%E1%BA%B9p/id1447215019?l=vi"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  {gs.icons({
                    name: "appstore",
                    width: "180px",
                    height: "52px",
                  })}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionDownloadApp;
